const checkActiveSession = () => {
    /* refresh page if cookie has expired */
    setInterval(() => {
        const cookie = document.cookie;
        if (cookie.indexOf('XSRF-TOKEN') < 0) {
            window.location = '/logged-out';
        }
    }, 2000);
}

export default checkActiveSession;
